export default __webpack_public_path__ + "static/media/LOC有机物自动分析仪用户手册_V2.0_fmt_pdf.baab75ef.pdf";